// utils/linkify.ts
export const URL_RE = /((?:https?:\/\/|www\.)[^\s<]+)/gi;

export function escapeHtml(s: string) {
  return s.replace(/[&<>"']/g, (c) => ({
    "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#039;"
  }[c] as string));
}

export function toAnchors(text: string) {
  return escapeHtml(text).replace(URL_RE, (m) => {
    const href = m.startsWith("http") ? m : `https://${m}`;
    const safeHref = escapeHtml(href);
    const safeText = escapeHtml(m);
    return `<a href="${safeHref}" target="_blank" rel="noopener noreferrer" contenteditable="false">${safeText}</a>`;
  });
}
